import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="border-y border-electric/30 bg-industrial py-16 sm:py-20" aria-labelledby="results-title" data-id="element-108" data-mp="28eg99jwmki7p">
      <div className="mx-auto max-w-6xl px-4" data-id="element-109" data-mp="2d79ba00plcg3">
        <SectionHeading id="results-title" data-id="element-110" data-mp="2h81kwudhtjcw">What <span className="text-gold" data-id="element-111" data-mp="2h7092nonksu4">professionals</span> say</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-112" data-mp="2m5lb8sngtml7">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-electric/40 bg-navy p-6 shadow-glow" data-id="element-113" data-mp="2r690b8s4vtcs" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-electric" aria-hidden="true" data-id="element-114" data-mp="3neqxl3cjw7rn" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-steel" data-id="element-115" data-mp="3ilxusl0n79i7">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-electric/20 pt-4" data-id="element-116" data-mp="3do61pno9hhcf">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-electric/60 bg-industrial font-display text-sm font-extrabold text-silver" data-id="element-117" data-mp="38puvro137qzh">
                  {initials}
                </span>
                <span data-id="element-118" data-mp="5608ba314lp6">
                  <b className="block text-sm text-silver" data-id="element-119" data-mp="870ydpzplnb">{name}</b>
                  <small className="text-xs text-steel" data-id="element-120" data-mp="aku2h140ns8">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}